import { mapGetters } from 'vuex';

const GENERAL = {
  computed: {
    ...mapGetters({
      permissions: 'permissions',
    }),
  },
  methods: {

    /**
         * Scroll animation
         */
    scrollAnimation () {
      const elements = document.getElementsByClassName('before-animated');

      const functionAnimation = () => {
        const heightWindow = Math.round(window.innerHeight);

        for (const item of elements) {
          const blockTop = Math.round(item.getBoundingClientRect().top);
          const typeAnimation = item.getAttribute('data-animation-type');
          const delayAnimation = item.getAttribute('data-animation-delay');

          if (blockTop < heightWindow / 1.5) {
            item.style.transitionDelay = delayAnimation;
            item.classList.remove(`before-animated--${typeAnimation}`);
            item.classList.add('after-animated');
          }
        }
      };

      functionAnimation();
    },

    /**
         * Download blob file on link
         *
         * @param {String} data
         * @param {String} name
         */
    donwloadFileOnLink (data, name) {
      const link = document.createElement('a');
      link.setAttribute('id', 'download-link');
      link.style = 'display: none';
      document.body.appendChild(link);
      link.href = data;
      link.download = name;
      link.click();
      window.URL.revokeObjectURL(link);
      document.getElementById('download-link').remove();
    },

    /**
         * Download blob file on content
         *
         * @param {String} data
         * @param {String} name
         */
    donwloadFileOnContent (data, name) {
      const blob = new Blob([data]);
      const link = document.createElement('a');
      link.setAttribute('id', 'download-link');
      link.style = 'display: none';
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
      window.URL.revokeObjectURL(link);
      document.getElementById('download-link').remove();
    },

    /**
         * Check permission using array in store
         *
         * @return {Boolean}
         * @param {String} name
         */
    checkPermissions (prefix, name) {
      const namePermissions = name.replace(`${prefix}-`, `${prefix}.`);
      return this.permissions.includes(namePermissions) ? name : false;
    },

  },

};

export default GENERAL;
